import type { SVGProps } from 'react';
const SvgPublish = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#publish_svg__a)">
      <path fill="currentColor" d="M5 4v2h14V4H5Zm0 10h4v6h6v-6h4l-7-7-7 7Z" />
    </g>
    <defs>
      <clipPath id="publish_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPublish;
